import Image from 'next/image';

type IReviewCountryProps = {
  countryStart: string;
  countryEnd: string;
};

export const ReviewCountry = ({
  countryStart,
  countryEnd,
}: IReviewCountryProps) => {
  return (
    <div className={'flex gap-0.5 self-end'}>
      {countryStart && (
        <Image src={countryStart} alt={countryStart} width={24} height={24} />
      )}
      <Image
        src={'/static/icons/review.webp'}
        alt={'Review'}
        width={20}
        height={20}
      />
      {countryEnd && (
        <Image src={countryEnd} alt={countryEnd} width={24} height={24} />
      )}
    </div>
  );
};
